import React, { Component } from 'react';
import { connect } from 'react-redux';

import Page from '../components/Page';
import uploadProcessPDF from '../docs/tiip-data-upload-process-20180123.pdf';

class Resources extends Component{

    render() {
        return(
            <Page pageTitle="Resources">
                <div className="clearfix card" style={{ minHeight: "20em" }}>
                    <div className="col-sm-6">
                        <h5>TIIP Data Upload Process</h5>
                        <p>
                            This is a guide to uploading of policies using the template above: 
                        </p>
                        <p>
                            <a href={ uploadProcessPDF } className="download-link">
                                <i className="icon ion-document-text"></i>
                                TIIP Policy Upload Guide
                            </a>
                        </p>
                    </div>
                </div>
            </Page>
        )
    }
}

const mapStateToProps = ( state, ownProps) => ({
    user: state.user
});

export default connect(mapStateToProps)(Resources);


// WEBPACK FOOTER //
// ./src/pages/Resources.jsx